import { styled } from '@mui/material/styles';
import { Colors } from '../../../../../../ui/layout/theme-next';

export const SearchRoot = styled('div')({
  maxWidth: 350,
  margin: 'auto',
  backgroundColor: Colors.white,
  borderRadius: 3,
  '&.focused': {
    width: '100%',
    maxWidth: 'none',
  },
});

export const ListGroupLabel = styled('div')(({ theme }) => ({
  ...theme.typography.h6,
  padding: theme.spacing(1.25, 0),
  borderTop: `1px solid ${Colors.stroke}`,
  backgroundColor: Colors.white,
}));

export const ViewAll = styled('a')(({ theme }) => ({
  ...theme.typography.h6,
  padding: theme.spacing(0.5, 0),
  margin: theme.spacing(0.25, 2, 0),
  color: Colors.textGray,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const ListGroup = styled('ul')({
  padding: 0,
});

export const IconFocused = styled('div')({
  color: Colors.textBlack,
});
